import actions from "./actions";

const addRiderTip = actions.addRiderTip;
const removeRiderTip = actions.removeRiderTip;

export default {
  addRiderTip,
  removeRiderTip,
};
